import { render, staticRenderFns } from "./PortalWrapper.vue?vue&type=template&id=da7390e8&scoped=true"
import script from "./PortalWrapper.vue?vue&type=script&lang=ts"
export * from "./PortalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7390e8",
  null
  
)

export default component.exports